import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import getLayoutMode from '../utils/getLayoutMode';

export default function useLayoutMode() {
  const { pathname } = useLocation();
  return useMemo(() => getLayoutMode(pathname), [pathname]);
}
